import React from 'react';

export default () => (
  <div className="text-center">
    <h3>Sorry, page not found!</h3>
  </div>
);



// WEBPACK FOOTER //
// ./src/containers/NotFound.js